/**
 * Static prompt descriptors cycled through the search bar's animated placeholder.
 *
 * Lives in its own module so every composer surface ({@link ActivityAiSearchFilterPanel},
 * the homepage hero) shows the same rotation. These are PLACEHOLDER hints, not
 * clickable chips.
 */

type ActivityAiSuggestionDescriptor = {
    id: string;
    message: string;
};

export const SUGGESTION_DESCRIPTORS: ReadonlyArray<ActivityAiSuggestionDescriptor> = [
    {
        id: 'activity.search.ai.suggestion.25',
        message: 'Teambuilding with 25 people',
    },
    {
        id: 'activity.search.ai.suggestion.beach',
        message: 'Game on the beach',
    },
    {
        id: 'activity.search.ai.suggestion.generic',
        message: 'Outdoor problem solving',
    },
    {
        id: 'activity.search.ai.suggestion.belgianArdennes',
        message: 'Adventure day in the Belgian Ardennes',
    },
    {
        id: 'activity.search.ai.suggestion.indoorRainyDay',
        message: 'Rainproof indoor activity near Brussels',
    },
    {
        id: 'activity.search.ai.suggestion.lowBudget',
        message: 'Ideas under 45 EUR per person',
    },
    {
        id: 'activity.search.ai.suggestion.familyStyle',
        message: 'Relaxed family-style team event',
    },
    {
        id: 'activity.search.ai.suggestion.kickoff',
        message: 'Quarterly kick-off with energizers',
    },
    {
        id: 'activity.search.ai.suggestion.sustainability',
        message: 'Eco-friendly team challenge',
    },
    {
        id: 'activity.search.ai.suggestion.englishOnly',
        message: 'English-friendly activity for an international team',
    },
];
